export const LEAN_ESCAPE_ROUTES = [
  {
    path: '/',
    label: 'Go to Home',
  },
  {
    path: '/products',
    label: 'View Products',
  },
  {
    path: '/contact',
    label: 'Book a free 15-minute call',
  },
] as const;

export const REPORT_EMAIL = 'support@upcaret.com';
